
import AnimatedSection from '../../../components/base/AnimatedSection';

const WA_RESERVAR =
  "https://wa.me/5493415779623?text=Hola!%20Quiero%20reservar%20para%20ir%20a%20la%20Formaci%C3%B3n%20de%20Pergamino%20en%20La%20Usina%20Norte";

export default function Programa() {
  const modulo1Bloques = [
    {
      title: "Bloque 1",
      items: [
        "Qué puede hacer IA hoy en una empresa.",
        "Qué no conviene delegar.",
        "Cómo evitar salidas flojas.",
      ],
    },
    {
      title: "Bloque 2",
      items: [
        "Prompts que funcionan.",
        "Formatos de pedido para obtener resultados consistentes.",
      ],
    },
    {
      title: "Bloque 3",
      items: [
        "Práctica por casos.",
        "Ajustes, iteración, control de calidad.",
      ],
    },
    {
      title: "Bloque 4",
      items: [
        "Plan de aplicación.",
        "Cómo llevarlo a tu rutina sin frenarte.",
      ],
    },
  ];

  const almuerzo = {
    title: "Almuerzo de 13 a 14hs",
    items: [
      "Focaccia",
      "sandwich de miga",
      "sacramento j y q",
      "Aguas limonadas",
    ],
  };

  const modulo2Bloques = [
    {
      title: "Bloque 1",
      items: [
        "Psicología de Chat: Gatillos mentales para activar la compra.",
        "Escritura Persuasiva: Cómo evitar que te dejen en \"visto\".",
      ],
    },
    {
      title: "Bloque 2",
      items: [
        "Estructuras de Cierre: Flujo de ventas para canales digitales.",
        "Manejo de Objeciones: Guiones directos para desbloquear pagos.",
      ],
    },
    {
      title: "Bloque 3",
      items: [
        "IA Comercial: Uso de prompts para respuestas ultra-rápidas.",
        "Escala con Tecnología: Cómo atender a más leads en menos tiempo.",
      ],
    },
  ];

  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <AnimatedSection animation="fadeUp">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-16 text-center">
              Programa de la Formación - 9 a 17hs
            </h2>
          </AnimatedSection>

          {/* MÓDULO 1 */}
          <AnimatedSection animation="fadeUp">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-teal-500 text-white font-bold text-lg shrink-0">
                1
              </div>
              <h3 className="text-2xl font-bold text-teal-400 tracking-wide uppercase">
                Módulo 1
              </h3>
              <div className="flex-1 h-px bg-teal-500/30" />
            </div>
          </AnimatedSection>

          <div className="space-y-6 mb-10 pl-2">
            {modulo1Bloques.map((bloque, index) => (
              <AnimatedSection key={bloque.title + '-m1'} animation="fadeLeft" delay={index * 100}>
                <div className="bg-gray-900 border-l-4 border-teal-500 rounded-xl p-8">
                  <h4 className="text-xl font-bold text-white mb-4">
                    {bloque.title}
                  </h4>
                  <ul className="space-y-2 text-gray-300">
                    {bloque.items.map((item) => (
                      <li key={item} className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </AnimatedSection>
            ))}
          </div>

          {/* Almuerzo */}
          <AnimatedSection animation="fadeUp" delay={100}>
            <div className="bg-gradient-to-r from-teal-900/50 to-teal-800/30 rounded-xl p-8 border-l-4 border-teal-400 mb-10">
              <h3 className="text-2xl font-bold text-white mb-4">
                {almuerzo.title}
              </h3>
              <ul className="space-y-2 text-gray-300">
                {almuerzo.items.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </AnimatedSection>

          {/* MÓDULO 2 */}
          <AnimatedSection animation="fadeUp">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-rose-800 text-white font-bold text-lg shrink-0">
                2
              </div>
              <h3 className="text-2xl font-bold text-rose-400 tracking-wide uppercase">
                Módulo 2
              </h3>
              <div className="flex-1 h-px bg-rose-800/40" />
            </div>
          </AnimatedSection>

          <div className="space-y-6 mb-12 pl-2">
            {modulo2Bloques.map((bloque, index) => (
              <AnimatedSection key={bloque.title + '-m2'} animation="fadeRight" delay={index * 100}>
                <div className="bg-rose-950/40 rounded-xl p-8 border-l-4 border-rose-700">
                  <h4 className="text-xl font-bold text-white mb-4">
                    {bloque.title}
                  </h4>
                  <ul className="space-y-2 text-gray-300">
                    {bloque.items.map((item) => (
                      <li key={item} className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-rose-500 text-xl mt-0.5" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </AnimatedSection>
            ))}
          </div>

          <AnimatedSection animation="scaleUp" delay={200}>
            <div className="text-center">
              <a
                href={WA_RESERVAR}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold text-lg hover:bg-teal-400 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-teal-500/50"
              >
                Reservar mi lugar
              </a>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
